import { Info } from 'lucide-react'

import { usePriceInfoVariants } from '@/modules/Frontend/Theme'

interface PriceHintProps {
  tooltipId: string
  message: string
  visible: boolean
  onVisibleChange: (visible: boolean) => void
}

/** Info icon with its tooltip. Hover and keyboard focus both show the tooltip. */
export function PriceHint({ tooltipId, message, visible, onVisibleChange }: PriceHintProps) {
  const { priceInfoTooltipVariants } = usePriceInfoVariants()
  const show = () => onVisibleChange(true)
  const hide = () => onVisibleChange(false)

  return (
    <>
      <span
        className="cursor-help inline-flex"
        onMouseEnter={show}
        onMouseLeave={hide}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- intentionally focusable so keyboard users can trigger the price tooltip (onFocus/onBlur)
        tabIndex={0}
        onFocus={show}
        onBlur={hide}
        role="img"
        aria-label="Informatii pret"
        aria-describedby={visible ? tooltipId : undefined}
      >
        <Info className="w-4 h-4 xl:w-5 xl:h-5" />
      </span>
      {visible && (
        <div id={tooltipId} role="tooltip" className={priceInfoTooltipVariants()}>
          {message}
        </div>
      )}
    </>
  )
}
